import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    IconButton,
    Button,
    colors,
    Dialog,
    Paper,
    TextField,
    InputAdornment,
    Grid,
    Typography,
} from '@material-ui/core';

import SearchIcon from '@material-ui/icons/Search';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    hover: {
        border: "1px solid #000!important",
    },
    open: {
        height: "52px !important",
        border: "2px solid #7957D5!important",
    },
    normal: {
        width: "100%",
        height: 54,
        fontSize: 36,
        borderRadius: 4,
        cursor: "pointer",
        border: "1px solid #ccc",
        textAlign: "center",
    }
}));

export const IconPicker = ({
    icons,
    value,
    handleChange,
    titleText,
    disabled,
    ...props }) => {
    const classes = useStyles();

    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(false);

    const [searchText, setSearchText] = useState("");
    const [filteredIcons, setFilteredIcons] = useState(icons ? [...icons] : []);

    const divClickHandler = () => {
        if (!disabled) setOpen(true)
    }

    const iconClickHandler = async (icon) => {
        if (handleChange)
            handleChange(icon);
        setOpen(false);
    }

    useEffect(() => {
        setFilteredIcons((icons ?? []).filter(icon => icon.cssClass.substring(3, icon.cssClass.length).includes(searchText ?? "")))
    }, [searchText])

    return (
        <>
            <div
                className={clsx(classes.normal, hover && classes.hover, open && classes.open, props.className)}
                onMouseOver={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => divClickHandler()} >
                <Grid
                    container
                    alignItems="center"
                    justify="space-between">
                    <Grid
                        container
                        item xs="auto"
                        justify="center">
                        <i className={value} style={{ padding: 9 }} />
                    </Grid>
                    {/* <Grid item xs="auto">
                        <Button
                            variant="contained"
                            disableElevation
                            disabled={disabled}
                            style={{ width: 54, height: 54, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}>
                            <SearchIcon />
                        </Button>
                    </Grid> */}
                </Grid>
            </div>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                style={{ maxHeight: "80vh", margin: "auto" }}>
                <Paper style={{ minWidth: 580 }}>
                    <div style={{ margin: 4 }}>
                        <Typography
                            variant="h6"
                            align="center"
                            gutterBottom
                            style={{ color: "#727272" }}>
                            {titleText ?? "Pick an icon"}
                        </Typography>
                        <TextField
                            variant="outlined"
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>,
                            }}
                            style={{ padding: 8, width: 556 }}
                            onChange={(e) => { setSearchText(e.target.value) }}
                        >

                        </TextField>
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid container>
                                    {!filteredIcons || filteredIcons.length === 0 &&
                                        <Grid item xs="12">
                                            <Typography align="center" style={{ padding: 32 }}>
                                                No icons available
                                            </Typography>
                                        </Grid>
                                    }
                                    {(filteredIcons ?? []).map(icon =>
                                        <Grid
                                            key={icon.code}
                                            item
                                            style={{ width: 48, fontSize: 48, margin: 2, display: "flex", alignItems: "center" }}>
                                            <IconButton
                                                style={{ width: 48, }}
                                                disabled={disabled}
                                                onClick={() => iconClickHandler(icon)}>
                                                <i className={icon.cssClass} />
                                            </IconButton>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </Dialog>
        </>
    )
}